export function getProductImages(product) {
  if (!product) return [];

  return [product.image1, product.image2, product.image3, product.image4]
    .filter((img) => typeof img === 'string')
    .map((img) => img.trim())
    .filter(Boolean);
}

export function getPrimaryProductImage(product) {
  const [firstImage] = getProductImages(product);
  return firstImage || null;
}
